export const STATUS_SCHEDULED = 'Scheduled';
export const STATUS_RUNNING = 'Running';
export const STATUS_MEASURING = 'MeasuringResults';
export const STATUS_COMPLETED = 'Completed';
export const STATUS_FAILED = 'Failed';
export const STATUS_DELETED = 'Deleted';

export const statuses = {
  [STATUS_MEASURING]: {
    badgeColor: 'informative',
    code: STATUS_MEASURING,
    name: _TL_('Measuring results'),
    infoTitle: _TL_("We're creating your experiment"),
    infoText: _TL_("Your experiment {{name}} has finished running and we're measuring results."),
  },
  [STATUS_RUNNING]: {
    badgeColor: 'informative',
    code: STATUS_RUNNING,
    name: _TL_('Active'),
    infoTitle: _TL_('Your experiment is active'),
    infoText: _TL_("Your experiment {{name}} is currently running as expected. Once it's complete, you can view the results. Note: You can't edit active experiments."),
  },
  [STATUS_SCHEDULED]: {
    badgeColor: 'important',
    code: STATUS_SCHEDULED,
    name: _TL_('Scheduled'),
    infoTitle: _TL_('Your experiment has been scheduled'),
    infoText: _TL_('Your experiment {{name}} is scheduled to run on {{startDate}}. Note: You can still edit this this experiment before it runs.'),
  },
  [STATUS_FAILED]: {
    badgeColor: 'danger',
    code: STATUS_FAILED,
    name: _TL_('Experiment failed'),
    infoTitle: _TL_('Your experiment has failed'),
    infoText: _TL_("Your experiment {{name}} failed. Your campaign(s) didn't meet the eligibility requirements to run the experiment. Please review the eligibility requirements that appear in the Summary pane during experiment creation."),
  },
  [STATUS_COMPLETED]: {
    badgeColor: 'success',
    code: STATUS_COMPLETED,
    name: _TL_('Completed'),
    infoTitle: _TL_('Your experiment is complete'),
    infoText: _TL_('Your experiment {{name}} has completed.'),
  },
};
